module.exports = __webpack_public_path__ + "img/4.34375b9e.png";